import * as http from "http";
import https from "https";

import { Server } from "socket.io";

import { SingletonController } from "../../Commons/HttpServer/ExpressWrapper/SingletonController";

import { interceptStdStreams } from "./StdStreamsIntercepter";

export class BuildLogsWebsocketController extends SingletonController {
    private socketIoServer?: Server;
    private socketIoHttpsServer?: Server;

    public constructor() {
        super();
        interceptStdStreams(this.handleOutput);
    }

    public async afterStart(httpServer: http.Server, httpsServer?: https.Server): Promise<void> {
        this.socketIoServer = new Server(httpServer, {
            transports: ["websocket", "polling"],
            path: "/build-info",
        });
        if (httpsServer != undefined) {
            this.socketIoHttpsServer = new Server(httpsServer, {
                transports: ["websocket", "polling"],
                path: "/build-info",
            });
        }
    }

    private readonly handleOutput = (text: string): void => {
        this.socketIoServer?.emit("message", text);
        this.socketIoHttpsServer?.emit("message", text);
    };
}
